import './UfNavButtons.css';
import { IconButton } from '../../components/IconButton';
import { type CopyKey, t } from '../../copy/strings';
import { closePlace, stepUf } from '../../state/actions';
import { useLayout } from '../../state/hooks';

/** Cartão cujo × os botões fecham; só a UF tem ‹ › (§8.1 bloco 2). */
export type PlaceNavKind = 'uf' | 'municipality' | 'abroad' | 'country' | 'abroad-city';

/** Nome acessível do × por cartão (§8.1 bloco 8, chaves canônicas de §13.6). */
const CLOSE_KEY: Readonly<Record<PlaceNavKind, CopyKey>> = {
  uf: 'place.close.uf',
  municipality: 'place.close.municipality',
  abroad: 'place.close.abroad',
  country: 'place.close.country',
  'abroad-city': 'place.close.city',
};

export interface UfNavButtonsProps {
  kind: PlaceNavKind;
}

/**
 * ‹ › × no canto do cartão (§8.1, §5.5.3–§5.5.4): na UF, `stepUf(−1/+1)` (ordem alfabética do nome, circular) e
 * `closePlace()`; nos demais, só ×. O × vai direto ao Brasil do cargo atual (F17), nunca ao nível de cima. Na TV o mapa
 * é inerte e o cartão não tem botões (§8.1 bloco 4). A ordem do DOM (‹ › ×) é a de tabulação de §15.2.4.
 */
export function UfNavButtons({ kind }: UfNavButtonsProps) {
  if (useLayout().mode === 'tv') return null;
  const uf = kind === 'uf';
  return (
    <div class="uf-nav-buttons" data-testid="uf-nav-buttons">
      {uf ? (
        <IconButton
          icon="chevron-left"
          label={t('place.prevUf')}
          class="uf-nav-buttons__prev"
          onClick={() => stepUf(-1)}
        />
      ) : null}
      {uf ? (
        <IconButton
          icon="chevron-right"
          label={t('place.nextUf')}
          class="uf-nav-buttons__next"
          onClick={() => stepUf(1)}
        />
      ) : null}
      <IconButton icon="close" label={t(CLOSE_KEY[kind])} class="uf-nav-buttons__close" onClick={() => closePlace()} />
    </div>
  );
}
